// extracted by mini-css-extract-plugin
module.exports = {"summary__subtitle":"FrameworkSummary_summary__subtitle__1Y7rP","summary__download":"FrameworkSummary_summary__download__d_2aV"};